import { render, staticRenderFns } from "./MultiselectTag.vue?vue&type=template&id=696240ae"
import script from "./MultiselectTag.vue?vue&type=script&lang=ts"
export * from "./MultiselectTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696240ae')) {
      api.createRecord('696240ae', component.options)
    } else {
      api.reload('696240ae', component.options)
    }
    module.hot.accept("./MultiselectTag.vue?vue&type=template&id=696240ae", function () {
      api.rerender('696240ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectTag.vue"
export default component.exports